import { useRef } from "react";
import { Calendar } from "../../../components/Calendar/Calendar";
import { Button } from "../../../components/Button/Button";
import { formatDateLong } from "../../../utils/time";
import styles from "../BookingFlow.module.css";

interface StepDateProps {
  selectedDate: string | null;
  onSelectDate: (date: string) => void;
  onContinue: () => void;
}

export function StepDate({ selectedDate, onSelectDate, onContinue }: StepDateProps) {
  const headingRef = useRef<HTMLHeadingElement>(null);

  return (
    <section aria-labelledby="dmm-step-date-heading">
      <h2 id="dmm-step-date-heading" ref={headingRef} tabIndex={-1} className={styles.stepHeading}>
        Wanneer is jouw evenement?
      </h2>
      <p className={styles.stepIntro}>
        Selecteer een beschikbare datum. Een aanvraag is vrijblijvend. De datum is pas definitief
        gereserveerd nadat je van ons een bevestiging per e-mail hebt ontvangen.
      </p>

      <Calendar selectedDate={selectedDate} onSelectDate={onSelectDate} />

      <p className={styles.chosenDate} aria-live="polite">
        {selectedDate
          ? `Gekozen datum: ${formatDateLong(selectedDate)}`
          : "Nog geen datum gekozen."}
      </p>

      <div className={styles.actionsRow}>
        <Button type="button" onClick={onContinue} disabled={!selectedDate}>
          Verder met deze datum
        </Button>
      </div>
    </section>
  );
}
